import { useEffect, useState, useMemo, useRef } from 'react';

import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    AspectRatio,
    Box,
    Button,
    Card,
    Divider,
    Flex,
    FormControl,
    Heading,
    Icon,
    Image,
    Link,
    ListItem,
    Popover,
    PopoverAnchor,
    PopoverArrow,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
    Portal,
    Select,
    SlideFade,
    Spacer,
    Text,
    UnorderedList,
    useBreakpointValue,
    Tag,
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    FormLabel
} from '@chakra-ui/react';

import { DataTable } from './Misc/DataTable';
import { SongDataItem } from './Misc/SongDataItem';

export function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id }
}) {
  // Calculate the options for filtering
  // using the preFilteredRows
  const options = useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  return (
    <Select
      size={"xs"}
      value={filterValue}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
      variant={"outline"}
    >
      <option value="">All</option>
      {options.map((option, i) => (
        <option key={i} value={option}>
          {option}
        </option>
      ))}
    </Select>
  );
}

export function Ranking({eventConfig, getRanking}) {

    const isMobile = useBreakpointValue(
        {
          "base": ()=> true,
          "xl": ()=>  false
        }
    );     

    const srpgShort = eventConfig["eventShort"];

    let hasItgSingle = eventConfig["hasItgSingle"];
    let hasItgDouble = eventConfig["hasItgDouble"];
    let hasPumpSingle = eventConfig["hasPumpSingle"];
    let hasPumpDouble = eventConfig["hasPumpDouble"];

    const hasItg = useMemo(()=>(hasItgSingle || hasItgDouble), [hasItgSingle, hasItgDouble]);
    const hasPump = useMemo(()=>(hasPumpSingle || hasPumpDouble), [hasPumpSingle, hasPumpDouble]);

    const hasSingle = useMemo(()=>(hasItgSingle || hasPumpSingle), [hasItgSingle, hasPumpSingle]);
    const hasDouble = useMemo(()=>(hasItgDouble || hasPumpDouble), [hasItgDouble, hasPumpDouble]);

    const refreshTime = 180000;

    const [rankingTableSort, setRankingTableSort] = useState([]);

    const [chartData, setChartData] = useState(false);
    const [rankingData, setRankingData] = useState(false);
    const [rankingFilter, setRankingFilter] = useState({});
    
    const [rankingGame, setRankingGame] = useState("");
    const [rankingType, setRankingType] = useState("");
    const [rankingGender, setRankingGender] = useState("");
    const [rankingAllSort, setRankingAllSort] = useState("best");

    const rankingDataRequest = async () => {
        const newRankingData = await getRanking();

        console.log(newRankingData);

        const chartData = newRankingData?.chartData
            ? newRankingData.chartData
            : [];

        const rankingData = newRankingData?.rankingData
            ? newRankingData.rankingData
            : [];

        setChartData([...chartData]);
        setRankingData([...rankingData]);
    };

    useEffect(()=>{
        let newRankingTableSort = [];

        let newRankingFilter = updateRankingFilter("registration_best_total", "", false);
        newRankingFilter = updateRankingFilter("registration_best_singles", "", false, newRankingFilter);
        newRankingFilter = updateRankingFilter("registration_best_doubles", "", false, newRankingFilter);
        newRankingFilter = updateRankingFilter("registration_best_itg", "", false, newRankingFilter);
        newRankingFilter = updateRankingFilter("registration_best_pump", "", false, newRankingFilter);
        newRankingFilter = updateRankingFilter("registration_overall_points", "", false, newRankingFilter);
        newRankingFilter = updateRankingFilter("registration_singles_points", "", false, newRankingFilter);
        newRankingFilter = updateRankingFilter("registration_doubles_points", "", false, newRankingFilter);
        newRankingFilter = updateRankingFilter("registration_itg_points", "", false, newRankingFilter);
        newRankingFilter = updateRankingFilter("registration_pump_points", "", false, newRankingFilter);
        newRankingFilter = updateRankingFilter("registration_itg_singles_total", "", false, newRankingFilter);
        newRankingFilter = updateRankingFilter("registration_itg_doubles_total", "", false, newRankingFilter);
        newRankingFilter = updateRankingFilter("registration_pump_singles_total", "", false, newRankingFilter);        
        newRankingFilter = updateRankingFilter("registration_pump_doubles_total", "", false, newRankingFilter);   
        
        if (rankingGame === "" && rankingType === "") {
            newRankingFilter = updateRankingFilter("registration_best_total", [1], false, newRankingFilter);
            newRankingTableSort = [{ 
                id: rankingAllSort === "combined" ? "registration_overall_points" : "registration_best_total",
                desc: true
            }];
        } else if (rankingGame === "" && rankingType === "single") {
            newRankingFilter = updateRankingFilter("registration_best_singles", [1], false, newRankingFilter);
            newRankingTableSort = [{ 
                id: rankingAllSort === "combined" ? "registration_singles_points" : "registration_best_singles",
                desc: true
            }];    
        } else if (rankingGame === "" && rankingType === "double") {
            newRankingFilter = updateRankingFilter("registration_best_doubles", [1], false, newRankingFilter);
            newRankingTableSort = [{ 
                id: rankingAllSort === "combined" ? "registration_doubles_points" : "registration_best_doubles",
                desc: true
            }];
        } else if (rankingGame === "itg" && rankingType === "") {
            newRankingFilter = updateRankingFilter("registration_best_itg", [1], false, newRankingFilter);
            newRankingTableSort = [{ 
                id: rankingAllSort === "combined" ? "registration_itg_points" : "registration_best_itg",
                desc: true
            }];
        } else if (rankingGame === "itg" && rankingType === "single") {
            newRankingFilter = updateRankingFilter("registration_itg_singles_total", [1], false, newRankingFilter);
            newRankingTableSort = [{ 
                id: "registration_itg_singles_total",
                desc: true
            }];
        } else if (rankingGame === "itg" && rankingType === "double") {
            newRankingFilter = updateRankingFilter("registration_itg_doubles_total", [1], false, newRankingFilter);
            newRankingTableSort = [{ 
                id: 'registration_itg_doubles_total',
                desc: true
            }];                 
        } else if (rankingGame === "pump" && rankingType === "") {
            newRankingFilter = updateRankingFilter("registration_best_pump", [1], false, newRankingFilter);
            newRankingTableSort = [{ 
                id: rankingAllSort === "combined" ? "registration_pump_points" : "registration_best_pump",
                desc: true
            }];            
        } else if (rankingGame === "pump" && rankingType === "single") {
            newRankingFilter = updateRankingFilter("registration_pump_singles_total", [1], false, newRankingFilter);
            newRankingTableSort = [{ 
                id: 'registration_pump_singles_total',
                desc: true
            }];                
        } else if (rankingGame === "pump" && rankingType === "double") {
            newRankingFilter = updateRankingFilter("registration_pump_doubles_total", [1], false, newRankingFilter);
            newRankingTableSort = [{ 
                id: 'registration_pump_doubles_total',
                desc: true
            }];             
        } 

        setRankingTableSort(newRankingTableSort);
        setRankingFilter(newRankingFilter);
    },[rankingGame, rankingType, rankingAllSort]);

    const updateRankingFilter = (id=false, value=false, doSet=true, passedRankingFilter=false) => {
        const newRankingFilter = passedRankingFilter ? {...passedRankingFilter} : {...rankingFilter};

        if (value === "") {
            delete newRankingFilter[id];
        } else {
            newRankingFilter[id] = value;
        }

        if (doSet) {
            setRankingFilter(newRankingFilter);
        } else {
            return newRankingFilter;
        }
    };

    const gameTypeCount = useMemo(()=>{
        let newGameCount = 0;

        newGameCount = hasItgSingle
            ? newGameCount + 1
            : newGameCount;

        newGameCount = hasItgDouble
            ? newGameCount + 1
            : newGameCount;
            
        newGameCount = hasPumpSingle
            ? newGameCount + 1
            : newGameCount;      

        newGameCount = hasPumpDouble
            ? newGameCount + 1
            : newGameCount;   

        return newGameCount;
    }, [hasItgSingle, hasItgDouble, hasPumpSingle, hasPumpDouble]);

    useEffect(()=>{
        if (hasItg && hasPump) {
            setRankingGame("")
        } else if (hasItg) {
            setRankingGame("itg")
        } else if (hasPump) {
            setRankingGame("pump")
        }
    },[hasItgSingle, hasItgDouble, hasPumpSingle, hasPumpDouble])

    useEffect(()=>{
        if (rankingGame === "") {
            if (hasSingle && hasDouble) {
                setRankingType("");
            } else if (hasSingle && !hasDouble) {
                setRankingType("single");
            } else if (!hasSingle && hasDouble) {
                setRankingType("double");
            }
        } else if (rankingGame === "itg") {
            if (hasItgSingle && hasItgDouble) {
                setRankingType("");
            } else if (hasItgSingle && !hasItgDouble) {
                setRankingType("single");
            } else if (!hasItgSingle && hasItgDouble) {
                setRankingType("double");
            }
        } else if (rankingGame === "pump") {
            if (hasPumpSingle && hasPumpDouble) {
                setRankingType("");
            } else if (hasPumpSingle && !hasPumpDouble) {
                setRankingType("single");
            } else if (!hasPumpSingle && hasPumpDouble) {
                setRankingType("double");
            }
        }
    },[rankingGame]);

    const initialState = useMemo(()=>{
        return { 
            pageIndex: 0, 
            pageSize: 9999,
            sortBy: [
                {
                    id: 'registration_best_total',
                    desc: true
                }
            ]
        }
    }, []);

    const columns = useMemo(() => 
        [
            {
                Header: isMobile() ? "#" : "Rank",
                accessor: "",
                Cell: (row) => {
                    const rowIds = [];
                    row.sortedRows.forEach((sortedRow)=>{
                        rowIds.push(sortedRow.index);
                    });
                    
                    const rank = rowIds.indexOf(row.row.index) + 1;
                    return <div>{rank}</div>;
                },
                disableSortBy: true,
                disableFilters: true,
                width: 20,
            },
            {
                Header: "Player",
                accessor: `members_name`,
                Filter: "",
                filter: "",
                width: 100,
                disableSortBy: true,
            },
            {
                Header: "Gender",
                accessor: `members_sex`,
                Filter: "",
                filter: "equals",
                width: 60,
                disableSortBy: true,
                show: !isMobile()
            },
            {
                Header: isMobile() ? "TPX" : "ITG Single TPX",
                accessor: "registration_itg_singles_tpx",
                Filter: "",
                filter: "",
                width: 65,
                disableSortBy: true,                
                show:    
                    hasItgSingle && rankingGame === "itg" && rankingType === "single"              
            },        
            {
                Header: isMobile() ? "LPX" : "ITG Single LPX",
                accessor: "registration_itg_singles_lpx",
                Filter: "",
                filter: "",
                sortType: "number",
                width: 65,
                disableSortBy: true,                
                show:
                    hasItgSingle && rankingGame === "itg" && rankingType === "single"
            },                
            {
                Header: isMobile()
                        ? "Total" 
                        : rankingGame === ""
                            ? "ITG Single"
                            : "ITG Single Total",                
                accessor: "registration_itg_singles_total",
                Filter: "",
                filter: "between",
                sortType: "number",
                width: 85,
                disableSortBy: true,                
                show:
                    hasItgSingle && ((rankingGame === "itg" && (rankingType === "single" || (!isMobile() && rankingType === ""))) || (!isMobile() && rankingGame === "" && (rankingType === "single" || rankingType === "")))
            },
            {
                Header: isMobile() ? "TPX" : "ITG Double TPX",
                accessor: "registration_itg_doubles_tpx",
                Filter: "",
                filter: "",
                width: 65,
                disableSortBy: true,                
                show:    
                    hasItgDouble && rankingGame === "itg" && rankingType === "double"               
            },
            {
                Header: isMobile() ? "LPX" : "ITG Double LPX",
                accessor: "registration_itg_doubles_lpx",
                Filter: "",
                filter: "",
                sortType: "number",
                width: 65,
                disableSortBy: true,                
                show:
                    hasItgDouble && rankingGame === "itg" && rankingType === "double"
            },
            {
                Header: 
                    isMobile() 
                        ? "Total" 
                        : rankingGame === ""
                            ? "ITG Double"
                            : "ITG Double Total",
                accessor: "registration_itg_doubles_total",
                Filter: "",
                filter: "between",
                sortType: "number",
                width: 85,
                disableSortBy: true,                
                show:
                    hasItgDouble && ((rankingGame === "itg" && (rankingType === "double" || (!isMobile() && rankingType === ""))) || (!isMobile() && rankingGame === "" && (rankingType === "double" || rankingType === "")))
            },        
            {
                Header: isMobile() ? "TPX" : "Pump Single TPX",
                accessor: "registration_pump_singles_tpx",
                Filter: "",
                filter: "",
                sortType: "number",
                width: 65,
                disableSortBy: true,                
                show:    
                    hasPumpSingle && rankingGame === "pump" && rankingType === "single"              
            },        
            {
                Header: isMobile() ? "LPX" : "Pump Single LPX",
                accessor: "registration_pump_singles_lpx",
                Filter: "",
                filter: "",
                sortType: "number",
                width: 65,
                disableSortBy: true,                
                show:
                    hasPumpSingle && rankingGame === "pump" && rankingType === "single"
            },                
            {
                Header: isMobile()
                        ? "Total" 
                        : rankingGame === ""
                            ? "Pump Single"
                            : "Pump Single Total",                 
                accessor: "registration_pump_singles_total",
                Filter: "",
                filter: "between",
                sortType: "number",
                width: 85,
                disableSortBy: true,                
                show:
                    hasPumpSingle && ((rankingGame === "pump" && (rankingType === "single" || (!isMobile() && rankingType === ""))) || (!isMobile() && rankingGame === "" && (rankingType === "single" || rankingType === "")))
            },
            {
                Header: isMobile() ? "TPX" : "Pump Double TPX",
                accessor: "registration_pump_doubles_tpx",
                Filter: "",
                filter: "",
                width: 65,
                disableSortBy: true,                
                show:    
                    hasPumpDouble && rankingGame === "pump" && rankingType === "double"             
            },
            {
                Header: isMobile() ? "LPX" : "Pump Double LPX",
                accessor: "registration_pump_doubles_lpx",
                Filter: "",
                filter: "",
                sortType: "number",
                width: 65,
                disableSortBy: true,                
                show:
                    hasPumpDouble && rankingGame === "pump" && rankingType === "double"
            },                
            {
                Header: 
                    isMobile() 
                        ? "Total" 
                        : rankingGame === ""
                            ? "Pump Double"
                            : "Pump Double Total",                
                accessor: "registration_pump_doubles_total",
                Filter: "",
                filter: "between",
                sortType: "number",
                width: 85,
                disableSortBy: true,                
                show:
                    hasPumpDouble && ((rankingGame === "pump" && (rankingType === "double" || (!isMobile() && rankingType === ""))) || (!isMobile() && rankingGame === "" && (rankingType === "double" || rankingType === "")))
            },
            {
                Header: isMobile() ? "All" : "Combined",
                accessor: "registration_itg_points",
                Filter: "",
                filter: "",
                sortType: "number",
                width: 85,
                disableSortBy: true,                
                show:
                    rankingGame === "itg" && rankingType === ""
            },             
            {
                Header: isMobile() ? "All" : "Combined",
                accessor: "registration_pump_points",
                Filter: "",
                filter: "",
                sortType: "number",
                width: 85,
                disableSortBy: true,                
                show:
                    rankingGame === "pump" && rankingType === ""
            },     
            {
                Header: isMobile() ? "All" : "Combined",
                accessor: "registration_singles_points",
                Filter: "",
                filter: "",
                sortType: "number",
                width: 85,
                disableSortBy: true,                
                show:
                    rankingGame === "" && rankingType === "single"
            },               
            {
                Header: isMobile() ? "All" : "Combined",
                accessor: "registration_doubles_points",
                Filter: "",
                filter: "",
                sortType: "number",
                width: 85,
                disableSortBy: true,                
                show:
                    rankingGame === "" && rankingType === "double"
            },                                        
            {
                Header: isMobile() ? "All" : "Combined",
                accessor: "registration_overall_points",
                Filter: "",
                filter: "",
                /* this isn't sortable so we can't actually use it, but maybe good example for some other time
                Cell: (row) => {
                    const rowCells = row?.row?.allCells;
                    
                    const itgSingleTotal = parseInt(rowCells.filter((cell)=>(cell?.column?.id === "registration_itg_singles_total"))[0]?.value);
                    const itgDoubleTotal = parseInt(rowCells.filter((cell)=>(cell?.column?.id === "registration_itg_doubles_total"))[0]?.value);
                    const pumpSingleTotal = parseInt(rowCells.filter((cell)=>(cell?.column?.id === "registration_pump_singles_total"))[0]?.value);
                    const pumpDoubleTotal = parseInt(rowCells.filter((cell)=>(cell?.column?.id === "registration_pump_doubles_total"))[0]?.value);

                    const dbCombinedTotal = parseInt(rowCells.filter((cell)=>(cell?.column?.id === "registration_overall_points"))[0]?.value);

                    let combinedTotal = 0;

                    if (rankingGame === "") {
                        if (rankingType === "") {
                            //combinedTotal = itgSingleTotal + itgDoubleTotal + pumpSingleTotal + pumpDoubleTotal;
                            combinedTotal = dbCombinedTotal;
                        } else if (rankingType === "single") {
                            combinedTotal = itgSingleTotal + pumpSingleTotal;
                        } else if (rankingType === "double") {
                            combinedTotal = itgDoubleTotal + pumpDoubleTotal;
                        }
                    } else if (rankingGame === "itg") {
                        if (rankingType === "") {
                            combinedTotal = itgSingleTotal + itgDoubleTotal;
                        } else if (rankingType === "single") {
                            //shouldn't be relevant
                            combinedTotal = itgSingleTotal;
                        } else if (rankingType === "double") {
                            //shouldn't be relevant
                            combinedTotal = itgDoubleTotal;
                        }
                    } else if (rankingGame === "pump") {
                        if (rankingType === "") {
                            combinedTotal = pumpSingleTotal + pumpDoubleTotal;
                        } else if (rankingType === "single") {
                            //shouldn't be relevant
                            combinedTotal = pumpSingleTotal;
                        } else if (rankingType === "double") {
                            //shouldn't be relevant
                            combinedTotal = pumpDoubleTotal;
                        }                        
                    }

                    return <div>{combinedTotal}</div>;
                },                
                */
                sortType: "number",
                width: 85,
                disableSortBy: true,                
                show:
                    rankingGame === "" && rankingType === ""
            },          
            {
                Header: isMobile() ? "Best" : "Best",
                accessor: "registration_best_itg",
                Filter: "",
                filter: "between",    
                sortType: "number",
                width: 85,
                disableSortBy: true,
                show:
                    rankingGame === "itg" && rankingType === ""
            },  
            {
                Header: isMobile() ? "Best" : "Best",
                accessor: "registration_best_pump",
                Filter: "",
                filter: "between",    
                sortType: "number",
                width: 85,
                disableSortBy: true,
                show:
                    rankingGame === "pump" && rankingType === ""
            },
            {
                Header: isMobile() ? "Best" : "Best",
                accessor: "registration_best_singles",
                Filter: "",
                filter: "between",    
                sortType: "number",
                width: 85,
                disableSortBy: true,
                show:
                    rankingGame === "" && rankingType === "single"
            },
            {
                Header: isMobile() ? "Best" : "Best",
                accessor: "registration_best_doubles",
                Filter: "",
                filter: "between",    
                sortType: "number",
                width: 85,
                disableSortBy: true,
                show:
                    rankingGame === "" && rankingType === "double"
            },            
            {
                Header: isMobile() ? "Best" : "Best",
                accessor: "registration_best_total",
                Filter: "",
                filter: "between",    
                /*  maybe this will be useful later but unsortable so not useful now
                Cell: (row) => {
                    const rowCells = row?.row?.allCells;
                    
                    const itgSingleTotal = parseInt(rowCells.filter((cell)=>(cell?.column?.id === "registration_itg_singles_total"))[0]?.value);
                    const itgDoubleTotal = parseInt(rowCells.filter((cell)=>(cell?.column?.id === "registration_itg_doubles_total"))[0]?.value);
                    const pumpSingleTotal = parseInt(rowCells.filter((cell)=>(cell?.column?.id === "registration_pump_singles_total"))[0]?.value);
                    const pumpDoubleTotal = parseInt(rowCells.filter((cell)=>(cell?.column?.id === "registration_pump_doubles_total"))[0]?.value);

                    const dbBestTotal = parseInt(rowCells.filter((cell)=>(cell?.column?.id === "registration_best_total"))[0]?.value);

                    let bestTotal = 0;

                    if (rankingGame === "") {
                        if (rankingType === "") {
                            //bestTotal = Math.max(itgSingleTotal, itgDoubleTotal, pumpSingleTotal, pumpDoubleTotal);
                            bestTotal = dbBestTotal;
                        } else if (rankingType === "single") {
                            bestTotal = Math.max(itgSingleTotal, pumpSingleTotal);
                        } else if (rankingType === "double") {
                            bestTotal = Math.max(itgDoubleTotal, pumpDoubleTotal);
                        }
                    } else if (rankingGame === "itg") {
                        if (rankingType === "") {
                            bestTotal = Math.max(itgSingleTotal, itgDoubleTotal);
                        } else if (rankingType === "single") {
                            //shouldn't be relevant
                            bestTotal = itgSingleTotal;
                        } else if (rankingType === "double") {
                            //shouldn't be relevant
                            bestTotal = itgDoubleTotal;
                        }
                    } else if (rankingGame === "pump") {
                        if (rankingType === "") {
                            bestTotal = Math.max(pumpSingleTotal, pumpDoubleTotal);
                        } else if (rankingType === "single") {
                            //shouldn't be relevant
                            bestTotal = pumpSingleTotal;
                        } else if (rankingType === "double") {
                            //shouldn't be relevant
                            bestTotal = pumpDoubleTotal;
                        }                        
                    }

                    return <div>{bestTotal}</div>;
                },                 
                */
                sortType: "number",
                width: 85,
                disableSortBy: true,
                show:
                    rankingGame === "" && rankingType === ""
            },          
        ]
        , [rankingGame, rankingType, isMobile()]
    );

    const extraRankingData = (data, additionalData) => {
        const itgSingleTpxCharts = data?.registration_itg_singles_tpx_charts
            ? JSON.parse(data.registration_itg_singles_tpx_charts)
            : false;

        const itgSingleLpxCharts = data?.registration_itg_singles_lpx_charts
            ? JSON.parse(data.registration_itg_singles_lpx_charts)
            : false;

        const itgDoubleTpxCharts = data?.registration_itg_doubles_tpx_charts
            ? JSON.parse(data.registration_itg_doubles_tpx_charts)
            : false;

        const itgDoubleLpxCharts = data?.registration_itg_doubles_lpx_charts
            ? JSON.parse(data.registration_itg_doubles_lpx_charts)
            : false;

        const pumpSingleTpxCharts = data?.registration_pump_singles_tpx_charts
            ? JSON.parse(data.registration_pump_singles_tpx_charts)
            : false;

        const pumpSingleLpxCharts = data?.registration_pump_singles_lpx_charts
            ? JSON.parse(data.registration_pump_singles_lpx_charts)
            : false;

        const pumpDoubleTpxCharts = data?.registration_pump_doubles_tpx_charts
            ? JSON.parse(data.registration_pump_doubles_tpx_charts)
            : false;

        const pumpDoubleLpxCharts = data?.registration_pump_doubles_lpx_charts
            ? JSON.parse(data.registration_pump_doubles_lpx_charts)
            : false;       

        const getDataByChartId = (chartId) => {
            return additionalData.filter((chart) => {return chart?.chart_id === chartId})[0];
        }

        const getScoreColor = (score) => {       
            switch (true) {
                case score >= 10000:
                    return "#0B3D0B";
                case score >= 9900:
                    return "#145A32";
                case score >= 9500:
                    return "#1E8449";
                case score >= 9000:
                    return "#2E7D32";
                case score >= 8500:
                    return "#3E6E1E";
                case score >= 8000:
                    return "#5A6B1E";
                case score >= 7500:
                    return "#A07911";
                case score >= 7000:
                    return "#C25B06";
                case score >= 6500:
                    return "#A93226";
                case score >= 6000:
                    return "#7B241C";
                default:
                    return "#7B241C"
            }
        }

        const chartDataPopover = (chartData) => {
            return (
                <Flex flexWrap={{base: "wrap", xl: "nowrap"}} flexDirection="row" >
                    <Box marginBottom={3} marginRight={3}>
                        <Heading size="md" marginBottom={3}>Song Data</Heading>
                        <Flex direction="column" wrap="wrap" >
                            <SongDataItem headerText="Song" valueText={chartData[`${srpgShort}_charts_song`]}/>
                            <SongDataItem headerText="Rating" valueText={chartData[`${srpgShort}_charts_rating`]}/>                            
                            <SongDataItem headerText="BPM" valueText={chartData[`${srpgShort}_charts_bpm`]}/>          
                            <SongDataItem headerText="Type" valueText={data[`${srpgShort}_charts_faction`] == 4 ? "Double Only" : "Single & Double"}/>
                            <SongDataItem headerText="Stepartist" valueText={chartData[`${srpgShort}_charts_stepartist`]}/>
                            <SongDataItem headerText="Pack" valueText={chartData[`${srpgShort}_charts_pack`]}/>                  
                            <SongDataItem headerText="Steps" valueText={chartData[`${srpgShort}_charts_steps`]}/>
                            <SongDataItem headerText="16ths" valueText={`${chartData[`${srpgShort}_charts_16ths`]} measures`}/>
                            {
                                chartData[`${srpgShort}_charts_24ths`] > 0 && (
                                    <SongDataItem headerText="24ths" valueText={`${chartData[`${srpgShort}_charts_24ths`]} measures`}/>
                                )
                            }      
                            {
                                chartData[`${srpgShort}_charts_32nds`] > 0 && (
                                    <SongDataItem headerText="32nds" valueText={`${chartData[`${srpgShort}_charts_32nds`]} measures`}/>
                                )
                            }                                    
                            <SongDataItem headerText="Break" valueText={`${chartData[`${srpgShort}_charts_break`]} measures`}/>                
                            <SongDataItem headerText="Stream %" valueText={`${(chartData[`${srpgShort}_charts_adjstream`]*100).toFixed(2)}%`}/>                    
                        </Flex>
                    </Box>
                    <Box>
                        <Heading size="md" marginBottom={3}>Breakdown</Heading>
                        <Card padding={2} maxWidth={{base: "275px", xl: "400px"}} bgColor="whiteAlpha.300" style={{textWrapMode: "wrap"}}>
                            {chartData[`${srpgShort}_charts_breakdown`]}
                        </Card>                        
                    </Box>
                </Flex>                
            )            
        }

        const topPassDisplay = (header, tpxCharts, lpxCharts, total) => {
            return ((tpxCharts || lpxCharts) && (
                <Card flex='1' minWidth={isMobile() ? "300px" : "550px"} bgColor="whiteAlpha.200">
                    <Accordion defaultIndex={[isMobile() ? -1 : 0]} allowMultiple>
                        <AccordionItem>
                            <AccordionButton>
                                <Flex pr={isMobile() ? "15px": "30px"} width="100%">
                                    <Box as='span' flex='1' textAlign='left'>
                                        <Heading size="xs">{header}</Heading>
                                    </Box>
                                    <Spacer/>
                                    <Box>
                                        <Heading size="xs">{total} Total</Heading>
                                    </Box>
                                </Flex>
                                <AccordionIcon />
                            </AccordionButton>
                            <AccordionPanel pb={4}>   
                                {
                                    tpxCharts && (
                                        <>
                                            <Tag>Best TPX Clears</Tag>                                
                                            <Table size="sm" mb={4}>
                                                <Thead>
                                                    <Tr display="flex" flex="1 0 auto" minWidth="0px">
                                                        {!isMobile() && (
                                                            <Th textAlign="center" width="50px">Diff</Th>
                                                        )}
                                                        <Th textAlign="center" width={isMobile() ? "125px" : "350px"}>Song</Th>
                                                        <Th textAlign="center" paddingLeft="1px" paddingRight="1px" width="60px">Score</Th>                                
                                                        <Th textAlign="center" width="50px">TPX</Th>                                
                                                        <Th textAlign="center" width="50px">LPX</Th>                                
                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    {
                                                        tpxCharts.map((chart) => (
                                                            <Popover trigger={isMobile() ? "click" : "hover"}>
                                                                <PopoverTrigger>
                                                                    <Tr display="flex" flex="1 0 auto" minWidth="0px">
                                                                        {!isMobile() && (
                                                                            <Td textAlign="center" width="50px">{getDataByChartId(chart.chartId)[`${srpgShort}_charts_rating`]}</Td>
                                                                        )}                                                                
                                                                        <Td textAlign="center" width={isMobile() ? "125px" : "350px"} textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap">
                                                                            {getDataByChartId(chart.chartId)[`${srpgShort}_charts_song`]}</Td>
                                                                        <Td bgColor={getScoreColor(chart.score)}  fontWeight="bold" textAlign="center" paddingLeft="1px" paddingRight="1px" width="60px">{`${(chart.score/100).toFixed(2)}%`}</Td>
                                                                        <Td fontWeight="bold" textAlign="center" width="50px">{chart.tpx}</Td>
                                                                        <Td fontWeight="bold" textAlign="center" width="50px">{chart.lpx}</Td>
                                                                    </Tr>
                                                                </PopoverTrigger>
                                                                <Portal>
                                                                    <PopoverContent bgColor={"gray.900"} width={{base: "300px", xl: "700px"}}>
                                                                        <PopoverArrow/>
                                                                        <PopoverBody>
                                                                            {chartDataPopover(getDataByChartId(chart.chartId))}
                                                                        </PopoverBody>   
                                                                    </PopoverContent>
                                                                </Portal>                                                                                                                             
                                                            </Popover>
                                                        ))
                                                    }
                                                </Tbody>
                                            </Table>    
                                        </>                            
                                    )
                                }  

                                {
                                    lpxCharts && (
                                        <>
                                            <Tag>Best LPX Clear</Tag>                                
                                            <Table size="sm">
                                                <Thead>
                                                    <Tr display="flex" flex="1 0 auto" minWidth="0px">
                                                        {!isMobile() && (
                                                            <Th textAlign="center" width="50px">Diff</Th>
                                                        )}                                                        
                                                        <Th textAlign="center" width={isMobile() ? "125px" : "350px"}>Song</Th>
                                                        <Th textAlign="center" paddingLeft="1px" paddingRight="1px" width="60px">Score</Th>                                
                                                        <Th textAlign="center" width="50px">TPX</Th>                                
                                                        <Th textAlign="center" width="50px">LPX</Th>                                
                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    {
                                                        lpxCharts.map((chart) => (
                                                            <Popover trigger={isMobile() ? "click" : "hover"}>
                                                                <PopoverTrigger>
                                                                    <Tr display="flex" flex="1 0 auto" minWidth="0px">
                                                                        {!isMobile() && (
                                                                            <Td textAlign="center" width="50px">{getDataByChartId(chart.chartId)[`${srpgShort}_charts_rating`]}</Td>
                                                                        )}                                                                    
                                                                        <Td textAlign="center" width={isMobile() ? "125px" : "350px"} textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap">
                                                                            {getDataByChartId(chart.chartId)[`${srpgShort}_charts_song`]}
                                                                        </Td>
                                                                        <Td bgColor={getScoreColor(chart.score)} fontWeight="bold" textAlign="center" paddingLeft="1px" paddingRight="1px" width="60px">{`${(chart.score/100).toFixed(2)}%`}</Td>
                                                                        <Td fontWeight="bold" textAlign="center" width="50px">{chart.tpx}</Td>
                                                                        <Td fontWeight="bold" textAlign="center" width="50px">{chart.lpx}</Td>
                                                                    </Tr>  
                                                                </PopoverTrigger>
                                                                <Portal>
                                                                    <PopoverContent bgColor={"gray.900"} width={{base: "300px", xl: "700px"}}>
                                                                        <PopoverArrow/>
                                                                        <PopoverBody>
                                                                            {chartDataPopover(getDataByChartId(chart.chartId))}
                                                                        </PopoverBody>   
                                                                    </PopoverContent>
                                                                </Portal>                                                                                                                             
                                                            </Popover>                                                                                                      
                                                        ))
                                                    }
                                                </Tbody>
                                            </Table>                                           
                                        </>                                      
                                    )                                
                                }     
                            </AccordionPanel>
                        </AccordionItem>
                    </Accordion>
                </Card>
            ));                       
        }        

        return (
            <>
                <Box width="100%" marginBottom={3}>
                    <Flex mb={4} alignItems="flex-end">
                        { (data?.members_profile_img && data.members_profile_img?.length > 0) && (
                            <Image flex="1" borderRadius={5} ml="auto" mr="auto" width="50px" src={data.members_profile_img} />
                        )}                    
                        <Heading flex="20" size="md" mb={3} ml={3}>{data?.["members_name"]}'s Passes:</Heading>
                    </Flex>                
                    <Flex gap="10px" flexWrap="wrap" flexDirection="row" alignItems="flex-start">
                        {topPassDisplay("ITG Single Scores", itgSingleTpxCharts, itgSingleLpxCharts, data?.registration_itg_singles_total)}
                        {topPassDisplay("ITG Double Scores", itgDoubleTpxCharts, itgDoubleLpxCharts, data?.registration_itg_doubles_total)}
                        {topPassDisplay("Pump Single Scores", pumpSingleTpxCharts, pumpSingleLpxCharts, data?.registration_pump_singles_total)}
                        {topPassDisplay("Pump Double Scores", pumpDoubleTpxCharts, pumpDoubleLpxCharts, data?.registration_pump_doubles_total)}       
                    </Flex>     
                    <Spacer/>        
                </Box>
            </>
        );
    }

    useEffect(() => {
        let intervalId;
        if(rankingData?.length > 0 && !eventConfig?.["eventOver"]) {
            intervalId = setInterval(rankingDataRequest, refreshTime);
        }
        // Clean up the interval when the component unmounts
        return () => clearInterval(intervalId);        
    }, [rankingData, refreshTime, eventConfig?.["eventOver"]]);

    useEffect(()=> {
        rankingDataRequest();
    }, []);

    try {
        return (
            <>
                {gameTypeCount > 1 && (
                    <Card mb={4} padding={4} maxWidth={"475px"}>
                        <Heading size="md" mb={3}>Filters</Heading>       
                        <Flex
                            flexFlow="row"
                            flexWrap="wrap"
                            alignSelf="center"
                            gap="15px"
                        >
                            {((hasItgSingle || hasItgDouble) && (hasPumpSingle || hasPumpDouble)) && (                        
                                <FormControl width="unset" variant="floatingCard">
                                    <Select                                
                                        minWidth="135px"
                                        value={rankingGame}
                                        cursor="pointer"
                                        onChange={(filter)=>{
                                            setRankingGame(filter.target.value)
                                        }}
                                    >
                                        <option value="">All</option>
                                        {(hasItgSingle || hasItgDouble) && (
                                            <option value="itg">ITG</option>
                                        )}
                                        {(hasPumpSingle || hasPumpDouble) && (
                                            <option value="pump">Pump</option>
                                        )}                                                                
                                    </Select>
                                    
                                    <FormLabel>Game</FormLabel>        
                                </FormControl> 
                            )}
                            {(((rankingGame === "" || rankingType === "") && hasSingle && hasDouble) || (rankingGame === "itg" && hasItgSingle && hasItgDouble) || (rankingGame === "pump" && hasPumpSingle && hasPumpDouble)) && (
                                <SlideFade in={(((rankingGame === "" || rankingType === "") && hasSingle && hasDouble) || (rankingGame === "itg" && hasItgSingle && hasItgDouble) || (rankingGame === "pump" && hasPumpSingle && hasPumpDouble))}>
                                    <FormControl width="unset" variant="floatingCard">
                                        <Select       
                                            width="unset"
                                            minWidth="135px"     
                                            value={rankingType}
                                            cursor="pointer"
                                            onChange={(filter)=>{
                                                setRankingType(filter.target.value)
                                            }}
                                        >
                                            <option value="">All</option>
                                            <option value="single">Single</option>
                                            <option value="double">Double</option>
                                        </Select>    
                                        <FormLabel>Type</FormLabel>  
                                    </FormControl>     
                                </SlideFade>                                                           
                            )}               
                            {(rankingGame === "" || rankingType === "") && gameTypeCount > 1 && (
                                <SlideFade in={(rankingGame === "" || rankingType === "") && gameTypeCount > 1}>
                                    <FormControl width="unset" variant="floatingCard">
                                        <Select       
                                            width="unset"
                                            minWidth="135px"     
                                            value={rankingAllSort}
                                            cursor="pointer"
                                            onChange={(filter)=>{
                                                setRankingAllSort(filter.target.value)
                                            }}
                                        >
                                            <option value="best">Best</option>
                                            <option value="combined">{isMobile() ? "All" : "Combined"}</option>                                        
                                        </Select>    
                                        <FormLabel>Sort By</FormLabel>  
                                    </FormControl>     
                                </SlideFade>                                                           
                            )}                                  
                            <FormControl width="unset" variant="floatingCard">
                                <Select        
                                    minWidth="135px"                
                                    value={rankingGender}
                                    cursor="pointer"
                                    onChange={(filter)=>{
                                        setRankingGender(filter.target.value);
                                        updateRankingFilter("members_sex", filter.target.value);
                                    }}
                                >
                                    <option value="">Any</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Unspecified">Unspecified</option>
                                </Select> 
                                <FormLabel>Gender</FormLabel>                                                 
                            </FormControl>                             
                        </Flex>                    
                    </Card>
                )}
                <Box width="100%">
                    {
                        (rankingData && rankingData?.length > 0)
                            ?
                                <DataTable data={rankingData} columns={columns} initialState={{...initialState}} customFilters={{...rankingFilter}} customTableSort={[...rankingTableSort]} subRowContents={extraRankingData} additionalData={chartData} searchEnabled={false}/>    
                            :   rankingData !== false
                                ?
                                    <Heading size="md">No scores submitted yet!</Heading>
                                :
                                    <Heading size="md">Please wait...</Heading>
                    }
                </Box>
            </>
        );
    } catch (e) {
        console.error("Ranking render error: ", e);
    }
}